import { Heading, Ilustration, Text } from '@orbita-ui/core';
import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Heading as="h1" bold>
        404
      </Heading>
      <Ilustration name="SystemError" />
      <Text>Pagina no encontrada</Text>
    </div>
  );
};

export default NotFoundPage;
